import { render, staticRenderFns } from "./TpmsEvents.vue?vue&type=template&id=788f13de&scoped=true"
import script from "./TpmsEvents.vue?vue&type=script&lang=js"
export * from "./TpmsEvents.vue?vue&type=script&lang=js"
import style0 from "./TpmsEvents.vue?vue&type=style&index=0&id=788f13de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f13de",
  null
  
)

export default component.exports